import React, { useState } from 'react';
import { Box, Pagination } from '@mui/material';
import { GestionDirigeantWidget, GestionDirigeantWidgetType } from '../../molecules';

export type GestionDirigeantListProps = {
    items?: Array<GestionDirigeantWidgetType>;
};

const ITEMS_PER_PAGE = 10;

export const GestionDirigeantList: React.FunctionComponent<GestionDirigeantListProps> = function (
    props: GestionDirigeantListProps,
) {
    const { items } = props;
    const [page, setPage] = useState(1);

    if (!items) return null;

    const totalPages = Math.ceil(items.length / ITEMS_PER_PAGE);
    const paginatedItems = items.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);

    return (
        <Box>
            {paginatedItems.map((itemProps: GestionDirigeantWidgetType, index) => (
                <GestionDirigeantWidget
                    key={`gestionDirigeant-${itemProps.gestionDirigeant.custom_l2d?.dateEffetModificationDirigeant ?? ''}-${itemProps.gestionDirigeant.individu?.descriptionPersonne?.nom ?? itemProps.gestionDirigeant.entreprise?.denomination ?? ''}`}
                    {...itemProps}
                    index={(page - 1) * ITEMS_PER_PAGE + index}
                />
            ))}
            {totalPages > 1 && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '16px',
                    }}
                >
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(_, value) => setPage(value)}
                        color="primary"
                        shape="rounded"
                    />
                </Box>
            )}
        </Box>
    );
};
